import { ClipboardList, Droplets, EyeOff, TrendingDown } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

type Problem = { Icon: LucideIcon; title: string; body: string };

const PROBLEMS: ReadonlyArray<Problem> = [
  {
    Icon: Droplets,
    title: 'Le surdosage',
    body: 'Un trait de rhum en trop à chaque verre, et la bouteille part deux fois plus vite. Sans recette, personne ne le voit.',
  },
  {
    Icon: EyeOff,
    title: 'Le coulage & le vol',
    body: 'Verres offerts sans ticket, bouteilles qui disparaissent. La caisse est juste, le stock non.',
  },
  {
    Icon: ClipboardList,
    title: 'Les comptages au feeling',
    body: 'L\'inventaire sur un cahier, le soir, fatigué. Les chiffres arrangent tout le monde sauf toi.',
  },
  {
    Icon: TrendingDown,
    title: 'La marge invisible',
    body: 'Tu vends bien mais tu gagnes peu. Sans coût par verre, impossible de savoir où la marge fuit.',
  },
];

export default function BarProblemV2() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <SectionLabel>Le vrai problème du bar</SectionLabel>
        <h2 className="mt-3 max-w-3xl font-marketing-display text-[clamp(30px,4.4vw,56px)] font-bold leading-[1.02] tracking-[-0.035em] text-charcoal-800">
          Sur les boissons, la marge <span className="underline-lime">fuit en silence.</span>
        </h2>
        <p className="mt-4 max-w-xl font-marketing-body text-[17px] leading-[1.55] text-charcoal-600">
          Un bar perd facilement 15 à 30% de sa marge boisson sans s'en rendre compte. Quatre fuites
          reviennent toujours.
        </p>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PROBLEMS.map(({ Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col gap-4 border-2 border-charcoal-800 bg-paper p-6 shadow-neobrutal-4"
            >
              <span className="flex h-12 w-12 items-center justify-center border-2 border-charcoal-800 bg-white text-terracotta-500 shadow-neobrutal-2">
                <Icon className="h-[22px] w-[22px]" strokeWidth={2} aria-hidden="true" />
              </span>
              <h3 className="font-marketing-display text-[19px] font-bold leading-[1.15] tracking-[-0.01em] text-charcoal-800">
                {title}
              </h3>
              <p className="font-marketing-body text-[14px] leading-[1.55] text-charcoal-600">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
